import { render, staticRenderFns } from "./SystemMonitor.vue?vue&type=template&id=3835f1a0&scoped=true"
import script from "./SystemMonitor.vue?vue&type=script&lang=js"
export * from "./SystemMonitor.vue?vue&type=script&lang=js"
import style0 from "./SystemMonitor.vue?vue&type=style&index=0&id=3835f1a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835f1a0",
  null
  
)

export default component.exports